module.exports = __webpack_public_path__ + "img/General Iroh-256.ec8cf1bd.png";